import React, { Fragment } from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        const sources = [
          {
            ...data.desktopImage.childImageSharp.fluid,
            media: '(min-width: 768px)'
          },
          data.mobileImage.childImageSharp.fluid
        ]
        return (
          <Root {...others}>
            <Container>
              <Head
                sub="COMPARISON"
                main={(
                  <Fragment>他社との<strong>比較</strong></Fragment>
                )}
                lead={(
                  <Head_Lead>外部依存せず全領域を自社で完結、<br />要望や修正にも柔軟に対応できます</Head_Lead>
                )}
                body={(
                  <Fragment>ECサイトの設計、デザイン、システム構築、運用まで、すべての領域を自社で完結できます。専属のフォトグラファー、ライターが在籍しているため、制作過程で発生する要望や修正等にも柔軟に対応可能。外部に依存しない小回りの効く体制だからこそ、高品質なサイトを短納期で構築できます。</Fragment>
                )}
              />
              <Table>
                <Table_Container>
                  <Image fluid={sources} alt="他者との比較" />
                </Table_Container>
              </Table>
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.b};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Head_Lead = styled.div`
  @media ${mq.and(mobile)} {
    br {
      display: none;
    }
  }
`

const Container = styled.div`
  margin: 0 auto;
`

const Table = styled.div`
  margin-top: ${rem(40)};
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
    overflow-x: auto;
    margin-left: -${rem(layouts.defs.pad.mobile)};
    margin-right: -${rem(layouts.defs.pad.mobile)};
    padding-bottom: ${rem(16)};
  }
`

const Table_Container = styled.div`
  @media ${mq.and(mobile)} {
    position: relative;
    width: 150%;
    padding-left: ${rem(layouts.defs.pad.mobile)};
    padding-right: ${rem(layouts.defs.pad.mobile)};
  }
`

const Image = styled(GatsbyImage)`
  width: 100%;
  > div:first-of-type {
    padding-bottom: ${props =>
      `${100 / props.fluid[0].aspectRatio}% !important`
    };
    @media ${mq.and(mobile)} {
      padding-bottom: ${props =>
        `${100 / props.fluid[1].aspectRatio}% !important`
      };
    }
  }
`

export const query = graphql`
  query CompareSectionQuery {
    desktopImage: file(relativePath: { eq: "compare.png" }) {
      childImageSharp {
        fluid(maxWidth: 1618, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    mobileImage: file(relativePath: { eq: "compare-mobile.png" }) {
      childImageSharp {
        fluid(maxWidth: 1618, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
